export default __webpack_public_path__ + "static/media/img-xls.2640e536.svg";